<template>
  <div class="container flex-column flex-justify-start flex-align-center">
    <div class="submenu flex-row flex-justify-start flex-align-start" v-if="subindex<=2">
      <div class="sm-item" :class="[{'sm-item-sel': subindex==1}]" @click="changeSubindex(1)">数据监控</div>
      <div class="sm-item" :class="[{'sm-item-sel': subindex==2}]" @click="changeSubindex(2)">地图监控</div>
    </div>
    <div class="data-monitor flex-column flex-justify-start flex-align-start" v-if="subindex==1">
      <div class="data-search flex-wrap flex-justify-start flex-align-start">
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">选择设备状态：</div>
          <el-select v-model="search.form.state" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in search.state"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属厂区：</div>
          <el-select v-model="search.form.changqu" placeholder="请选择" @change="handleChangqu" style="width: 250px">
            <el-option
              v-for="item in search.changqu"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属楼号：</div>
          <el-select v-model="search.form.louhao" placeholder="请选择" @change="handleLouhao" style="width: 250px">
            <el-option
              v-for="item in search.louhao"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">所属楼层：</div>
          <el-select v-model="search.form.louceng" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in search.louceng"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">抄表类型：</div>
          <el-select v-model="search.form.paratype" placeholder="请选择" style="width: 250px">
            <el-option
              v-for="item in search.paratype"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <div class="dsi-text">设备名称或编号：</div>
          <el-input v-model="search.form.sn" placeholder="设备名称或编号" style="width: 250px;"></el-input>
        </div>
        <div class="ds-item flex-row flex-justify-start flex-align-center">
          <el-button type="success" icon="el-icon-search" style="font-size: 14px; padding: 11px;" @click="handleMonSearch">查询</el-button>
        </div>
      </div>
      <div class="data-display flex-column flex-justify-start flex-align-center">
        <div class="gird-area flex-row flex-justify-start flex-align-start">
          <el-table :data="tableData" :header-cell-style="{'text-align': 'center', 'background-color': '#f5fafe'}" :cell-style="{'text-align': 'center'}" border style="width: 100%;">
            <el-table-column fixed prop="id" label="序号" width="50"></el-table-column>
            <el-table-column prop="sn" label="设备编号" width="200"></el-table-column>
            <el-table-column prop="name" label="设备名称" width="200"></el-table-column>
            <el-table-column prop="value" label="表具数值" width="100"></el-table-column>
            <el-table-column prop="metertype" label="设备类型" width="100"></el-table-column>
            <el-table-column prop="state" label="设备状态" width="100"></el-table-column>
            <el-table-column prop="errtype" label="故障类型" width="100"></el-table-column>
            <el-table-column prop="errmsg" label="故障说明"></el-table-column>
            <el-table-column prop="location" label="安装位置" width="200"></el-table-column>
            <el-table-column prop="paratype" label="抄表类型" width="100"></el-table-column>
            <el-table-column prop="datetime" label="抄表时间" width="200"></el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-tooltip effect="light" content="历史记录" placement="top-start">
                  <i class="el-icon-document" @click="handleHistory(scope.row)" style="cursor: pointer; font-size: 18px;"></i>
                </el-tooltip>
                <el-tooltip effect="light" content="地图" placement="top-start">
                  <i class="el-icon-place" @click="handleMap(scope.row)" style="cursor: pointer; font-size: 18px; margin-left: 5px;"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="data-page flex-row flex-justify-end flex-align-start">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="search.form.totalpage"
            :current-page.sync="search.form.currpage"
            :page-size="search.form.pagesize"
            @current-change="handleMonitorPage">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="data-monitor flex-row flex-justify-start flex-align-start" v-else-if="subindex==2">
      <div class="data-display flex-row flex-justify-start flex-align-start">
        <div class="mapl flex-column flex-justify-start flex-align-start">
          <div class="map-title">表具位置</div>
          <div style="width: 100%;padding-left: 20px;">
            <el-tree v-if="showTree" :expand-on-click-node="false" node-key="id" :default-expanded-keys="['1', '2']" :data="mappage.treeData" :props="{label: 'name', children: 'children'}">
              <span slot-scope="{node}" @click="handleTreeClick(node.data)" class="flex-row flex-justify-start flex-align-start">
                <span class="tree-node" :class="[{'tree-node-sel': node.data.id==mappage.selectd}]">
                  <span class="node-icon">
                    <i class="el-icon-folder" v-if="node.data.children && node.data.children.length" style="color: #f5a623;;"></i>
                    <i class="el-icon-document" v-else></i>
                  </span>
                  <span class="node-label">{{node.data.name}}</span>
                </span>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="mapr flex-column flex-justify-start flex-align-end">
          <div class="map-title">详细信息</div>
          <div class="dxf-container" ref="dxfref"></div>
        </div>
      </div>
    </div>
    <div class="hispage flex-column flex-justify-start flex-align-start" v-else-if="subindex==11">
      <div class="hhead flex-row flex-justify-start flex-align-center" style="margin-top: 10px;box-shadow: 0px -0.5px 0.5px 0.5px rgba(0, 0, 0, 0.4);">
        <div class="hheadl flex-row flex-justify-start flex-align-start">设备历史记录</div>
        <div class="hheadr flex-row flex-justify-end flex-align-start">
          <i class="el-icon-close" style="font-size: 16px; cursor: pointer;" @click="handleClose"></i>
        </div>
      </div>
      <div class="hhead flex-row flex-justify-start flex-align-center" style="box-shadow: 0px 0.5px 0.5px 0.5px rgba(0, 0, 0, 0.4);"><span style="margin-left: 10px;">{{ hispage.meterdetail }}</span></div>
      <div class="hsearch flex-wrap flex-justify-start flex-align-start">
        <div class="hsearch-item flex-row flex-justify-start flex-align-center">
          <div class="hsearch-text">开始日期：</div>
          <el-date-picker
            v-model="hispage.startTime"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </div>
        <div class="hsearch-item flex-row flex-justify-start flex-align-center">
          <div class="hsearch-text">结束日期：</div>
          <el-date-picker
            v-model="hispage.endTime"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </div>
        <div class="hsearch-item flex-row flex-justify-start flex-align-center">
          <el-button type="success" icon="el-icon-search" style="font-size: 14px; padding: 11px;" @click="handleHistorySearch">查询</el-button>
        </div>
      </div>
      <div class="his-display flex-column flex-justify-start flex-align-center">
        <div class="his-area flex-row flex-justify-start flex-align-start">
          <el-table :data="hispage.tableData" :header-cell-style="{'text-align': 'center', 'background-color': '#f5fafe'}" :cell-style="{'text-align': 'center'}" border style="width: 100%;">
            <el-table-column fixed prop="id" label="序号" width="50"></el-table-column>
            <el-table-column prop="value" label="表具数值"></el-table-column>
            <el-table-column prop="datetime" label="更新时间"></el-table-column>
            <el-table-column prop="user" label="修改人"></el-table-column>
            <el-table-column prop="paratype" label="录入方式"></el-table-column>
          </el-table>
        </div>
        <div class="data-page flex-row flex-justify-end flex-align-start">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="hispage.form.totalpage"
            :current-page.sync="hispage.form.currpage"
            :page-size="hispage.form.pagesize"
            @current-change="handleHisPage">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="hispage flex-column flex-justify-start flex-align-start" v-else-if="subindex==12">
      <div class="hhead flex-row flex-justify-start flex-align-center" style="margin-top: 10px;">
        <div class="hheadl flex-row flex-justify-start flex-align-start">地图</div>
        <div class="hheadr flex-row flex-justify-end flex-align-start">
          <i class="el-icon-close" style="font-size: 16px; cursor: pointer;" @click="handleClose"></i>
        </div>
      </div>
      <div class="hhead flex-row flex-justify-start flex-align-center"><span style="margin-left: 10px;">{{ hispage.meterdetail }}</span></div>
      <div class="his-display flex-column flex-justify-start flex-align-center">
        <div class="his-area flex-row flex-justify-start flex-align-start">
          <div class="dxf-container" ref="dxfref"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import * as THREE from 'three'
import DxfParser from 'dxf-parser'
import {getChangqu, getLouhao, getLouCeng, getMonitorData, getMeterHistory, getMapTree} from '@/api/engery.js'

export default {
  name: "EngeryMonior",
  data() {
    return {
      subindex: 1,
      lastsubindex: 1,
      showTree: false,
      scene: null,
      camera: null,
      renderer: null,
      controls: null,
      hispage: {
        form: {
          startTime: '',
          endTime: '',
          row: {},
          currpage: 1,
          pagesize: 15,
          totalpage: 15,
        },
        startTime: null,
        endTime: null,
        meterdetail: '',
        tableData: []
      },
      mappage: {
        selectd: '',
        treeData: []
      },
      search: {
        state: [
          {
            value: '全部',
            label: '全部'
          },
          {
            value: '正常',
            label: '正常'
          },
          {
            value: '故障',
            label: '故障'
          }
        ],
        changqu: [],
        louhao: [],
        louceng: [],
        paratype: [
          {
            value: '全部',
            label: '全部'
          },
          {
            value: '自动上传',
            label: '自动上传'
          },
          {
            value: '手工抄表',
            label: '手工抄表'
          }
        ],
        form: {
          state: '全部',
          changqu: '全部',
          louhao: '',
          louceng: '',
          paratype: '全部',
          sn: '',
          currpage: 1,
          pagesize: 15,
          totalpage: 15
        }
      },
      tableData: []
    }
  },
  async mounted() {
    const changqulist = await getChangqu()
    this.search.changqu = changqulist.data
    const response = await getMonitorData(this.search.form)
    this.search.form.totalpage = response.totalpage
    this.tableData = response.data
  },
  beforeDestroy() {
    // 清理资源，防止内存泄漏
    if (this.renderer) {
      this.renderer.dispose()
    }
  },
  methods: {
    async changeSubindex(index) {
      this.lastsubindex = this.subindex
      this.subindex = index
      if(index == 2) {
        const response = await getMapTree()
        this.mappage.treeData = response.data
        this.showTree = true
        this.mappage.selectd = ''
        setTimeout(() => {
          this.initThree()
          this.loadDxfFile('test.dxf')
        }, 500)
      }
      else if(index == 1) {
        const response = await getMonitorData(this.search.form)
        this.search.form.totalpage = response.totalpage
        this.tableData = response.data
        this.showTree = false
      }
      else {
        this.showTree = false
      }
    },
    async handleMonSearch() {
      const response = await getMonitorData(this.search.form)
      this.search.form.totalpage = response.totalpage
      this.tableData = response.data
    },
    handleTreeClick(param) {
      this.mappage.selectd = param.id
    },
    async handleChangqu(value) {
      this.search.form.louhao = ''
      this.search.louhao = []
      this.search.form.louceng = ''
      this.search.louceng = []
      if(value == '全部') {
        return
      }
      const result = this.search.changqu.filter(item => item.value == value)
      if(result.length == 0) return
      const response = await getLouhao(result[0].park_id)
      if(response.data.length <= 1) {
        return
      }
      this.search.louhao = response.data
      if(this.search.louhao.length > 0) {
        this.search.form.louhao = this.search.louhao[0].value
      }
    },
    async handleLouhao(value) {
      this.search.form.louceng = ''
      this.search.louceng = []
      if(value == '全部') {
        return
      }
      const result = this.search.louhao.filter(item => item.value == value)
      if(result.length == 0) return
      const response = await getLouCeng(result[0].building_id)
      if(response.data.length <= 1) {
        return
      }
      this.search.louceng = response.data
      if(this.search.louceng.length > 0) {
        this.search.form.louceng = this.search.louceng[0].value
      }
    },
    formatDateTime(now, sign) {
      const padZero = n => n < 10 ? `0${n}` : n
      let year = now.getFullYear()
      let month = padZero(now.getMonth() + 1)
      const day = padZero(now.getDate())
      const hour = padZero(now.getHours())
      const minute = padZero(now.getMinutes())
      const second = padZero(now.getSeconds())
      if(sign == 1) {
        month = padZero(month - 1)
        if(month == 0) {
          year -= 1
          month = 12
        }
      }
      const formatDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`
      return formatDate
    },
    async handleHistorySearch() {
      const startTime = this.formatDateTime(this.hispage.startTime, 0)
      this.hispage.form.startTime = startTime.substr(0, 10)
      const endTime = this.formatDateTime(this.hispage.endTime, 0)
      this.hispage.form.endTime = endTime.substr(0, 10)
      const response = await getMeterHistory(this.hispage.form)
      this.hispage.tableData = response.data
      this.hispage.form.totalpage = response.totalpage
    },
    async handleHistory(row) {
      this.hispage.meterdetail = row.sn + '：' + row.name + '；安装位置：' + row.location
      this.hispage.form.row = row
      const startTime = this.formatDateTime(new Date(), 1)
      this.hispage.form.startTime = startTime.substr(0, 10)
      this.hispage.startTime = new Date(this.hispage.form.startTime)
      const endTime = this.formatDateTime(new Date(), 0)
      this.hispage.form.endTime = endTime.substr(0, 10)
      this.hispage.endTime = new Date(this.hispage.form.endTime)
      const response = await getMeterHistory(this.hispage.form)
      this.hispage.tableData = response.data
      this.hispage.form.totalpage = response.totalpage
      this.changeSubindex(11)
    },
    handleMap(row) {
      this.hispage.meterdetail = row.sn + '：' + row.name + '；安装位置：' + row.location
      this.changeSubindex(12)
      setTimeout(() => {
        this.initThree()
        this.loadDxfFile('test.dxf')
      }, 500)
    },
    async handleMonitorPage(value) {
      const response = await getMonitorData(this.search.form)
      this.search.form.totalpage = response.totalpage
      this.tableData = response.data
    },
    async handleHisPage(value) {
      const startTime = this.formatDateTime(this.hispage.startTime, 0)
      this.hispage.form.startTime = startTime.substr(0, 10)
      const endTime = this.formatDateTime(this.hispage.endTime, 0)
      this.hispage.form.endTime = endTime.substr(0, 10)
      const response = await getMeterHistory(this.hispage.form)
      this.hispage.tableData = response.data
      this.hispage.form.totalpage = response.totalpage
    },
    handleClose() {
      this.changeSubindex(this.lastsubindex)
    },
    initThree() {
      if (this.renderer) {
        this.renderer.dispose()
      }
      const container = this.$refs.dxfref
      if(container == undefined) return
      const width = container.clientWidth
      const height = container.clientHeight
       // 1. 创建场景
      this.scene = new THREE.Scene()
      this.scene.background = new THREE.Color(0x222222) // 深色背景适合看图纸
      // 2. 创建相机
      this.camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 10000)
      this.camera.position.set(0, 0, 100)
      // 3. 创建渲染器
      this.renderer = new THREE.WebGLRenderer({ antialias: true })
      this.renderer.setSize(width, height)
      container.appendChild(this.renderer.domElement)
       // 4. 添加灯光（DXF 线条通常不需要复杂光照，但为了可见性可添加环境光）
      const ambientLight = new THREE.AmbientLight(0xffffff, 1)
      this.scene.add(ambientLight)
      // 5. 监听窗口大小变化
      window.addEventListener('resize', this.onWindowResize)
      // 6. 开始渲染循环
      this.animate()
    },
    async loadDxfFile(url) {
      try {
        const response = await fetch(url)
        const text = await response.text()
        // 使用 dxf-parser 解析
        const parser = new DxfParser()
        const dxfData = parser.parseSync(text) // 或者使用 parseAsync
        // 将解析后的数据转换为 Three.js 对象
        this.renderDxfEntities(dxfData.entities)
      } catch (error) {
        console.error('加载或解析 DXF 失败:', error)
      }
    },
    renderDxfEntities(entities) {
      if (!entities) return
      entities.forEach(entity => {
        let geometry
        let material = new THREE.LineBasicMaterial({ color: 0xffffff })
        // 简单示例：仅处理 LINE 类型，其他类型需额外处理
        if (entity.type === 'LINE') {
          const points = []
          points.push(new THREE.Vector3(entity.vertices.x, entity.vertices.y, 0))
          points.push(new THREE.Vector3(entity.vertices.x, entity.vertices.y, 0))
          geometry = new THREE.BufferGeometry().setFromPoints(points)
          
          const line = new THREE.Line(geometry, material)
          this.scene.add(line)
        } 
        // 这里需要补充 CIRCLE, ARC, LWPOLYLINE 等类型的转换逻辑
        // 实际项目中建议使用成熟的转换库如 'dxf-render' 或自行编写完整映射
      })
      // 调整相机位置以看到所有图形
      this.fitCameraToObject()
    },
    fitCameraToObject() {
      const box = new THREE.Box3().setFromObject(this.scene)
      const size = box.getSize(new THREE.Vector3())
      const center = box.getCenter(new THREE.Vector3())
      this.camera.position.copy(center)
      this.camera.position.z = size.length() * 1.5 // 后退一定距离
      this.camera.lookAt(center)
    },
    onWindowResize() {
      const container = this.$refs.container
      if (!container) return
      const width = container.clientWidth
      const height = container.clientHeight
      this.camera.aspect = width / height
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(width, height)
    },
    animate() {
      requestAnimationFrame(this.animate)
      this.renderer.render(this.scene, this.camera)
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
}
.submenu {
  width: 99%;
  margin-top: 10px;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
}
.sm-item {
  font-family: 'Arial';
  font-size: 18px;
  padding: 10px;
  margin-left: 20px;
}
.sm-item:hover {
  cursor: pointer;
}
.sm-item-sel {
  border-bottom-width: 2px;
  border-bottom-style: solid;
  border-bottom-color: #4660b6;
  color: #4660b6;
}
.data-monitor {
  width: 99%;
}
.data-search {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 10px;
}
.ds-item {
  margin-left: 20px;
  margin-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
.dsi-text {
  font-family: 'Arial';
  font-size: 16px;
  min-width: 140px;
  text-align: left;
}
.data-display {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
  margin-top: 20px;
  padding-bottom: 20px;
}
.gird-area {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 98%;
}
.data-page {
  width: 98%;
}
.hispage {
  width: 99%;
}
.hhead {
  width: 100%;
  font-family: 'Arial';
  font-size: 16px;
  background-color: #fff;
  padding: 10px;
}
.hheadl {
  width: 50%;
  margin-left: 10px;
}
.hheadr {
  width: 50%;
  margin-right: 10px;
}
.hsearch {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
  margin-top: 10px;
  padding-bottom: 10px;
}
.hsearch-item {
  margin-left: 20px;
  margin-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
.hsearch-text {
  font-family: 'Arial';
  font-size: 16px;
  min-width: 100px;
  text-align: left;
}
.his-display {
  width: 100%;
  background-color: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);
  margin-top: 20px;
  padding-bottom: 20px;
}
.his-area {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 98%;
}
.dxf-container {
  width: 100%;
  height: 800px;
  background-color: #333;
  overflow: auto;
}
.mapl {
  width: 30%;
  padding-bottom: 20px;
}
.mapr {
  width: 70%;
  padding-right: 20px;
  padding-bottom: 20px;
}
.map-title {
  width: 100%;
  font-family: 'Arial';
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.tree-node {
  gap: 5px;
  font-size: 13px;
  overflow: hidden;
  padding-left: 5px;
  padding-right: 5px;
}
.tree-node-sel {
  background-color: #ffebc0;
}
.node-icon {
  font-size: 14px;
  flex-shrink: 0;
  padding-right: 5px;
}
.node-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
